import { WppIcon, UnknownIcon, CashBuilderIcon, ChildIcon, SupremeIcon, EsteemeIcon, FamilyProtectionIcon, UppIcon } from '../icons';

export const productMappings = [
  { initials: 'WPP', webProductCode: '20', productName: 'Wealth Master Plus', icon: WppIcon, categoryCode: "2" },
  { initials: 'CLP', webProductCode: '1', productName: 'Child Lifeline Plus', icon: ChildIcon, categoryCode: "2" },
  { initials: 'UPP', webProductCode: '42', productName: 'Ultimate Protection Plus', icon: UppIcon, categoryCode: "3" },
  { 
    initials: 'EHP', 
    webProductCode: '43', 
    productName: 'Esteem Homecall Plus', 
    icon: EsteemeIcon,
    planCodes: {
      BASIC: '43',
      STANDARD: '44',
      PRESTIGE: '45',
      ELITE: '46',
      ULTIMATE: '47'
    },
    categoryCode: "3"
  },
  { initials: 'SUH', webProductCode: '99', productName: 'Supreme Homecall Plan', icon: SupremeIcon, categoryCode: "3" },
  { initials: 'CBP', webProductCode: '26', productName: 'Cashbuilder Plus', icon: CashBuilderIcon, categoryCode: "4" },
  { 
    initials: 'FPP', 
    webProductCode: '2', 
    productName: 'Family Protection Plan', 
    icon: FamilyProtectionIcon,
    planCodes: {
      BASIC: '2',
      STANDARD: '4',
      PRESTIGE: '5'
    },
    categoryCode: "3"
  },
  { initials: 'FCL', webProductCode: '81', productName: 'Fabulous Child Education', icon: ChildIcon, categoryCode: "2" },
  { initials: 'FWP', webProductCode: '79', productName: 'Fabulous Wealthmaster', icon: WppIcon, categoryCode: "2" },
  { initials: 'FUP', webProductCode: '80', productName: 'Fabulous Ultimate Protection', icon: UppIcon, categoryCode: "3" },
  {
    initials: 'FEH', 
    webProductCode: 'FEH', 
    productName: 'Fabulous Homecall', 
    icon: EsteemeIcon,
    planCodes: {
      BASIC: '82',
      STANDARD: '83',
      PRESTIGE: '84',
      ELITE: '85',
      ULTIMATE: '86'
    },
    categoryCode: "3"
  },
  { initials: 'PCL', webProductCode: '77', productName: 'Phobia Child Education', icon: ChildIcon, categoryCode: "2" },
  { initials: 'PUP', webProductCode: '65', productName: 'Phobia Ultimate Protection', icon: UppIcon, categoryCode: "3" },
  { initials: 'PWP', webProductCode: '66', productName: 'Phobia Wealth Master', icon: WppIcon, categoryCode: "2" },
  {
    initials: 'PEH', 
    webProductCode: 'PEH', 
    productName: 'Phobia Homecall', 
    icon: EsteemeIcon,
    planCodes: {
      BASIC: '67',
      STANDARD: '68',
      PRESTIGE: '69',
      ELITE: '70',
      ULTIMATE: '71'
    },
    categoryCode: "3"
  }
];